import PaginationBar from "components/shared/Pagination/PaginationBar";

export function PackagePagination({ page, totalPages, setPage, total }: any) {
    return (
        <PaginationBar
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            total={total}
        />
    );
}